import React from "react";
import { Pressable } from "react-native";
import { YStack, Text } from "tamagui";

type EventDetailDeleteButtonProps = {
  isVisible: boolean;
  onPress: () => void;
};

export const EventDetailDeleteButton = ({
  isVisible,
  onPress,
}: EventDetailDeleteButtonProps) => {
  if (!isVisible) return null;

  return (
    <YStack mt="$4" alignItems="center" justifyContent="center" gap="$4">
      <Pressable onPress={onPress}>
        <Text color="red" fontSize={20}>
          Delete Ride
        </Text>
      </Pressable>
    </YStack>
  );
};
